import reduceReducers from 'reduce-reducers';

//Siblings reducers
import loginReducer from './login-reducer';
import logoutReducer from './logout-reducer';
import resetPasswordReducer from './reset-password-reducer';

export default reduceReducers(
  loginReducer,
  logoutReducer,
  resetPasswordReducer,
);
